import { AppPhase } from '../types';
import { isGradeWorkspacePhase } from './appShellPhaseGroups';
import { appHomePhase, isAppShellEnabled, isAppShellPhase } from './appShellMode';

/**
 * Grading-only product: Grade workspace is the app.
 * Set `VITE_GRADING_ONLY_MODE=false` (or `VITE_GRADING_ONLY=false`) to restore the full shell.
 */
function readGradingOnlyEnv(): boolean | null {
  const values = [
    import.meta.env.VITE_GRADING_ONLY_MODE,
    import.meta.env.VITE_GRADING_ONLY,
    import.meta.env.VITE_DEMO_GRADE_ONLY,
  ];
  for (const raw of values) {
    if (raw === 'false') return false;
    if (raw === 'true') return true;
  }
  return null;
}

const envResolved = readGradingOnlyEnv();

export const GRADING_ONLY_MODE =
  envResolved === false ? false : envResolved === true || envResolved === null;

/** @deprecated Alias for {@link GRADING_ONLY_MODE} */
export const GRADING_ONLY_PRODUCT = GRADING_ONLY_MODE;

export function isGradingOnlyPhase(phase: AppPhase): boolean {
  return isGradeWorkspacePhase(phase);
}

/** Default signed-in surface: paper-scan workflow (not legacy Grade hub). */
export function gradeEntryPhase(): AppPhase {
  return GRADING_ONLY_MODE ? AppPhase.SCAN_WORKFLOW : AppPhase.DASHBOARD;
}

/**
 * Where signed-in users land. With the app shell enabled this is the Home
 * dashboard; otherwise it is the existing grade entry surface (unchanged
 * default-off behavior).
 */
export function appLandingPhase(): AppPhase {
  return isAppShellEnabled() ? appHomePhase() : gradeEntryPhase();
}

/**
 * Non-grade phases redirect to {@link gradeEntryPhase} when grading-only is
 * active. When `VITE_APP_SHELL` is enabled, the new app-shell phases (HOME,
 * GRADE_HOME, PLAN_HOME, COMMUNICATE_HOME, MANAGE_HOME) are allowed through;
 * legacy dormant shell phases are NOT.
 */
export function resolvePhaseForGradingOnly(phase: AppPhase): AppPhase {
  if (!GRADING_ONLY_MODE) return phase;
  if (isAppShellEnabled() && isAppShellPhase(phase)) return phase;
  return isGradingOnlyPhase(phase) ? phase : gradeEntryPhase();
}
